/* ============================================================
   es-add-to-bag.js — driver for snippets/es-add-to-bag.liquid.

   Lifted out of the identical inline <script> blocks in
   page.euro-summer-edit-case.liquid and
   page.euro-summer-edit-case-4.liquid so the case pages and the
   homepage Season Story section run one copy.

   Only the cart concerns moved. The scroll guard, the shipping
   banner mirror and the sticky case button stayed inline on the
   pages that need them — they are landing-page chrome, not part
   of adding to bag.

   Modes
   -----
   inline (default)  POST /cart/add.js, re-fetch /cart.js, sync the
                     store and flash "Added" on the button. The tray
                     stays shut. This is what both case pages have
                     always done and it is the default so they are
                     unchanged.
   tray              Hand off to the theme's Alpine cart store
                     (store.addToCart), which opens the tray and
                     shows the loading item exactly like a collection
                     tile or the PDP, then dispatch cart:updated for
                     gwp-auto-add. Falls back to the inline path if
                     the bundle has not booted.

   Opt in per control with data-es-add-mode="tray" on the
   [data-es-add] wrapper.

   Exports window.esSyncCart — snippets/es-case-builder.liquid calls
   it after packing a case, so it must keep that name.
   ============================================================ */
(function () {
  /* Run once per page, however many times this file is included.

     Every section that offers an add-to-bag emits its own
     <script src="es-add-to-bag.js" defer>, and the browser executes
     each tag even though it fetches the file once. Before this guard,
     a page with N such sections registered N document click listeners,
     so a single click on a size added the variant N times. One section
     per page (the homepage, the case pages) never showed it; the style
     feature template, which stacks six, did.

     Sections cannot coordinate with each other in Liquid, so the file
     has to be the thing that is idempotent. */
  if (window.__esAddToBagReady) return;
  window.__esAddToBagReady = true;

  var inFlight = false;

  function setCount(n) {
    document.querySelectorAll('[data-es-count]').forEach(function (el) {
      el.textContent = 'Case (' + n + ')';
    });
    var num = document.querySelector('[data-es-fab-n]');
    if (num) { num.textContent = n; num.hidden = !n; }
    var fab = document.querySelector('[data-es-fab]');
    if (fab) { fab.setAttribute('aria-label', 'View your case (' + n + (n === 1 ? ' item)' : ' items)')); }
  }

  /* --- site cart tray (Spruce 'cartStore', same API sections/main-cart.liquid uses) --- */
  function cartStore() {
    try {
      return (window.Spruce && typeof window.Spruce.store === 'function')
        ? window.Spruce.store('cartStore') : null;
    } catch (err) { return null; }
  }
  function trayUsable() {
    var t = document.querySelector('.tray[x-data*="cartTray"]');
    if (!t || getComputedStyle(t).display === 'none') return false;
    var s = cartStore();
    return !!(s && typeof s.showCartTray === 'function');
  }

  /* Keep the nav link, the sticky button and the tray's own contents in step.
     Our adds go straight to /cart/add.js, so the store needs telling. */
  function syncCart(cart) {
    if (!cart) return;
    setCount(cart.item_count);
    var s = cartStore();
    if (s) s.cart = cart;
  }
  window.esSyncCart = syncCart;   // es-case-builder calls this after packing

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-es-cart-open]')) return;
    if (!trayUsable()) return;    // no tray on the page — let the link go to /cart
    e.preventDefault();
    cartStore().showCartTray(true);
    /* refresh in the background in case anything else touched the cart */
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(syncCart)
      .catch(function () {});
  });

  function flash(btn, text) {
    var original = btn.dataset.esOriginal || btn.textContent;
    btn.dataset.esOriginal = original;
    btn.textContent = text;
    setTimeout(function () { btn.textContent = original; }, 1600);
  }

  function closeSizes(wrap, btn, label) {
    var sizes = wrap.querySelector('[data-es-sizes]');
    var opener = wrap.querySelector('[data-es-open]');
    if (sizes) sizes.hidden = true;
    if (opener) { opener.hidden = false; flash(opener, label); }
    else { flash(btn, label); }
  }

  /* The theme's own path: opens the tray, shows the loading item, then
     re-fetches. Same call collection tiles and the PDP make. */
  function addViaTray(variantId, btn, wrap) {
    var s = cartStore();
    if (!s || typeof s.addToCart !== 'function') return false;
    s.addToCart(Number(variantId));
    closeSizes(wrap, btn, 'Added');
    /* the store re-fetches on its own; mirror the count and let
       gwp-auto-add know once that has landed */
    setTimeout(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          syncCart(cart);
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(function () {});
    }, 800);
    inFlight = false;
    btn.disabled = false;
    return true;
  }

  function add(variantId, btn, wrap) {
    if (inFlight) return;
    inFlight = true; btn.disabled = true;

    if (wrap.dataset.esAddMode === 'tray' && addViaTray(variantId, btn, wrap)) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
    .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js'); })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      syncCart(cart);
      closeSizes(wrap, btn, 'Added');
      if (wrap.dataset.esAddMode === 'tray') {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
    })
    .catch(function () { flash(btn, 'Try again'); })
    .then(function () { inFlight = false; btn.disabled = false; });
  }

  function closeAll(except) {
    document.querySelectorAll('[data-es-add]').forEach(function (w) {
      if (w === except) return;
      var s = w.querySelector('[data-es-sizes]');
      var o = w.querySelector('[data-es-open]');
      if (s && !s.hidden) { s.hidden = true; if (o) o.hidden = false; }
    });
  }

  document.addEventListener('click', function (e) {
    var wrap = e.target.closest('[data-es-add]');
    closeAll(wrap);
    if (!wrap) return;
    var opener = e.target.closest('[data-es-open]');
    if (opener) {
      var sizes = wrap.querySelector('[data-es-sizes]');
      if (sizes) { sizes.hidden = false; opener.hidden = true; }
      return;
    }
    var btn = e.target.closest('[data-variant]');
    if (btn && !btn.disabled) add(btn.dataset.variant, btn, wrap);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });
})();
